import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Envion35Service {

  idEmpresa: string;
  idUsuario: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
this.obtienInfo();
  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idEmpresa = infoUsu.empresaId;
  }
  getProdCertAct(){
    this.obtienInfo();
    console.log(this.idEmpresa);

    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  getStatusEnvio(anio: number){
    this.obtienInfo();
    let datos: any = {fechaCertificar: anio,	envio: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusEnvio(anio: number){
    this.obtienInfo();
    let datos: any = {fechaCertificar: anio,	envio: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  // nEW SERVIDE

  getStatu( productoid:any, Idioma: any){
    this.obtienInfo();
    let datos: any = {productoId: productoid, envio:1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.wizardEnc.getStatus + this.idEmpresa, datos);
  }

  saveStatus(idproducto: any){
    this.obtienInfo();
    let datos: any = {productoId: idproducto,	envio: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.wizardEnc.sendStatus + this.idEmpresa, datos);
  }

  obtenerPilito(productoid:any){
    this.obtienInfo();
    let productoId: any = productoid
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getPilot + this.idEmpresa, productoId);
  }

  RecordatoriosManuales(datos:any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.sendRecordatorioEmail35 + this.idEmpresa, datos);
  }
  RecordatoriosManualesV3(datos:any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.enviarRecordaManuNormaV3 + this.idEmpresa, datos);
  }
  GetRecordatoriosManuales(datos:any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getRecordatorioManual35 + this.idEmpresa, datos);
  }

  obtenerPilito_Detail(productoid:any,idEmpresa){
    let productoId: any = productoid
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getPilot + idEmpresa, productoId);
  }

  DesbloquearPasoEnvio(datos){
    this.obtienInfo();
    console.log(datos);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.wizardEnc.sendStatus+ this.idEmpresa, datos);
  }

  getflag_email(data){
this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatus_correos+this.idEmpresa,data);
  }

  actualizaEstatusEnvioCorreo(datos){
    this.obtienInfo();
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.certificar2.envioCorreo.actualizaEstatusEnvioCorreos + this.idEmpresa+'/'+localStorage.getItem('productoID'),datos);
  }

  getEstatusEnvioCorreo(){
    this.obtienInfo();
  return this.http.get(DATOS_API.url + DATOS_API.endpoints.certificar2.envioCorreo.getEstatusEnvioCorreos + this.idEmpresa+'/'+localStorage.getItem('productoID'));
}



}
